import { render, staticRenderFns } from "./DefectsCategoriesCreateEdit.vue?vue&type=template&id=6976bde3"
import script from "./DefectsCategoriesCreateEdit.vue?vue&type=script&lang=js"
export * from "./DefectsCategoriesCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports